import Clarity from '@microsoft/clarity';

// Helper function to safely track Clarity custom events
export const addClarityEvent = (eventName: string) => {
  // Only track events in production environment
  if (process.env.NEXT_PUBLIC_ENV !== 'production') {
    return;
  }

  try {
    if (typeof window !== 'undefined') {
      Clarity.event(eventName);
    }
  } catch {
    // Event tracking failed, but don't break the app
  }
};
